<!-- tour-tile.component.html -->
<mat-card *ngIf="tour">
  <mat-card-header>
    <span class="tour-step">{{ tour.step }}</span>
    <mat-card-title>{{ tour.getTitle() }}</mat-card-title>
  </mat-card-header>
  <img mat-card-image loading="lazy" *ngIf="tour.imageUrl" [src]="tour.imageUrl" alt="{{ tour.title }}">
  <mat-card-content class="tour-content">
    <p class="tour-description">{{ tour.getDescription() }}</p>
  </mat-card-content>


  <mat-card-actions class="card-actions">
    <!--   <span class="rating">-->
    <!--    <mat-icon *ngFor="let star of [1, 2, 3, 4, 5]; let i = index" (click)="rateTour(i + 1)" matTooltip="{{i + 1}}">-->
    <!--        {{ i < tour.rating ? 'star' : 'star_border' }}-->
    <!--    </mat-icon>-->
    <!--</span>-->

    <ng-container *appRoleBasedDisplay="'admin'">
      <button mat-raised-button color="warning" [routerLink]="['/tours/edit', tour.id]" i18n>Edit</button>
      <button mat-raised-button color="warn" (click)="deleteTour()" i18n>Delete</button>
    </ng-container>
    <button mat-raised-button color="primary" [class.full-width]="!isLogged" [routerLink]="['/tours/view', tour.id]" i18n>Start</button>
  </mat-card-actions>
</mat-card>
